import Component from '../abstracts/Component';

export default class SeoTextComponent extends Component {
  constructor(compEl) {
    super(compEl);
    this.cta = this.$component.querySelector('[data-cta]');
    this.text = this.$component.querySelector('[data-text]');
    this.maxHeight = '150px';
  }

  isMobile() {
    let mq = window.matchMedia('(max-width: 767px)');
    let isMobile = mq.matches;
    return isMobile;
  }

  listenResize() {
    window.addEventListener('resize', () => {
      if (this.isMobile()) {
        this.text.style.maxHeight = this.maxHeight;
        this.textHandler();
      }
    });
  }

  textHandler() {
    this.text.style.maxHeight = this.maxHeight;
    if (this.text.scrollHeight >= 155) {
      this.cta.style.display = 'block';
      this.cta.addEventListener('click', () => {
        this.text.style.maxHeight = `${this.text.scrollHeight}px`;
        this.cta.style.display = 'none';
      });
    } else {
      this.cta.style.display = 'none';
    }
  }

  render() {
    this.log('Rendering...');
    this.listenResize();
    if (this.isMobile()) {
      this.textHandler();
    }
  }
}
